import { render, staticRenderFns } from "./AssembleTheNumberForm.vue?vue&type=template&id=2db61213&scoped=true&lang=pug&"
import script from "./AssembleTheNumberForm.vue?vue&type=script&lang=js&"
export * from "./AssembleTheNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./AssembleTheNumberForm.vue?vue&type=style&index=0&id=2db61213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db61213",
  null
  
)

export default component.exports